import { createApp } from "vue";
import { createPinia } from "pinia";
import { router } from "./router/index";
import QuizApp from "./QuizApp.vue";
import { installQuizRouterHooks } from "./router/install";

declare global {
    interface Window {
        launchQuiz?: () => void;
    }
}

function mountApp(auto = false) {
    const el = document.getElementById("quiz-app");
    let hooksInstalled = false;
    if (!el) return;

    if (!auto) {
        el.classList.remove("hidden");
        document.body.style.overflow = "hidden";
    }

    const app = createApp(QuizApp, {
        graphqlEndpoint: el.dataset.graphqlEndpoint || "/api",
        graphqlToken: el.dataset.graphqlToken || "",
        siteUrl: el.dataset.url || "",
        footerHtml: el?.dataset.footerHtml || "",
    });

    app.use(createPinia());
    app.use(router);

    if (!hooksInstalled) {
        installQuizRouterHooks(router);
        hooksInstalled = true;
    }
    app.mount("#quiz-app");
}

window.launchQuiz = () => {
    mountApp(false);

    requestAnimationFrame(() => {
        router.push("/welcome");
    });
};

const hash = window.location.hash || "";
const hasQuizRoute = hash.startsWith("#/") && hash.length > 2;

if (hasQuizRoute) {
    document.getElementById("quiz-app")?.classList.remove("hidden");
    mountApp(true);
    document.body.style.overflow = "hidden";
}
